// Expenses Reducer

const importsReducerDefaultState = [];

export default (state = importsReducerDefaultState, action) => {
    switch (action.type) {

        case 'IMPORT_EXPENSE':
            console.log("Action: IMPORT_EXPENSE ", action.metadata)
            return [
                ...state,
                action.metadata
            ]

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/imports.js